import React, { useRef, useState, Fragment, useEffect } from "react";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import petcozoolog from "../assets/petcozoolog.png";
import logoAn from "../assets/LogoAn.png";
import AppBar from "@mui/material/AppBar";
import Logo from "../assets/Logo.png";
import { styles } from "../theme/styles";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import Swal from "sweetalert2";

const FirmaPdf = () => {
  const { t } = useTranslation();
  const sigCanvas = useRef(null);
  const signatureRef = useRef({});
  const auxURL = process.env.REACT_APP_BACK_APIVENTAANIMALES;

  const [imageData, setImageData] = useState("");
  const handleClearCanvas = () => {
    sigCanvas.current.clear();
  };
  const saveSignature = async (signature) => {
    setImageData(signature);
    // crear servicio backend para guardar firma
    try {
      const resp = await axios.post(
        `${auxURL}/imagenes/guardarImagen`,
        {
          imageDataUri: signature,
          idImagen: "1234556",
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
            apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      //console.log("error al enviar la imagen a guardar", error);
    }
  };
  const onEnd = async () => {
    saveSignature(
      signatureRef.current.getTrimmedCanvas().toDataURL("image/jpg")
    );
  };
  useEffect(() => {}, [imageData]);
  return (
    <>
      <div style={styles.backgroundLog}>
        <AppBar
          position="static"
          color="primary"
          enableColorOnDark
          style={styles.head}>
          <img src={Logo} style={styles.logoP} alt="Logo" />
          <img src={logoAn} style={styles.logoAn} alt="Logo" />
        </AppBar>
        <div style={styles.body}>
          Favor de ingresar su firma en el siguiente recuadro:
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={styles.grid}>
            <div style={styles.logoContainer}>
              <SignatureCanvas
                onEnd={() =>
                  //mostrar mensaje de firma terminada
                  Swal.fire({
                    title: "¿Deseas guardar los cambios?",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Guardar",
                    confirmButtonColor: "#00205b",
                    denyButtonText: `Repetir Firma`,
                    denyButtonColor: "#818181",
                    cancelButtonText: "Cancelar",
                    cancelButtonColor: "#A30A40",
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      Swal.fire({
                        title: "Imagen Guardada con Éxito!",
                        icon: "success",
                        confirmButtonText: "Continuar",
                        confirmButtonColor: "#00205B",
                        iconColor: "green",
                      });
                      saveSignature(
                        sigCanvas.current
                          .getTrimmedCanvas()
                          .toDataURL("image/png")
                      );
                    } else if (result.isDenied) {
                      handleClearCanvas();
                      Swal.fire({
                        title: "Firma no guardada",
                        icon: "error",
                        confirmButtonText: "Aceptar",
                        iconColor: "red",
                        confirmButtonColor: "#00205B",
                      });
                    }
                  })
                }
                ref={sigCanvas}
                penColor="#00205B"
                canvasProps={{
                  width: 500,
                  height: 200,
                  style: {
                    border: "3px solid black",
                    backgroundColor: "transparent",
                    zIndex: 0,
                  },
                }}></SignatureCanvas>
            </div>
          </Grid>
        </div>
        <div></div>
      </div>
    </>
  );
};

export default FirmaPdf;
